import { render, staticRenderFns } from "./salesRefundList.vue?vue&type=template&id=06e270b0&scoped=true"
import script from "./salesRefundList.vue?vue&type=script&lang=js"
export * from "./salesRefundList.vue?vue&type=script&lang=js"
import style0 from "./salesRefundList.vue?vue&type=style&index=0&id=06e270b0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06e270b0",
  null
  
)

export default component.exports